"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var FormLabelWithHelpLink = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FormLabelWithHelpLink, _Component);

  function FormLabelWithHelpLink() {
    (0, _classCallCheck2.default)(this, FormLabelWithHelpLink);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormLabelWithHelpLink).apply(this, arguments));
  }

  (0, _createClass2.default)(FormLabelWithHelpLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          primaryText = _this$props.primaryText,
          linkText = _this$props.linkText,
          onLinkClick = _this$props.onLinkClick,
          required = _this$props.required;
      return _react.default.createElement(_UIFlex.default, {
        direction: "row",
        align: "baseline",
        justify: "between"
      }, _react.default.createElement(_UIFormLabel.default, {
        required: required
      }, _react.default.createElement(_FormattedMessage.default, {
        message: primaryText
      })), linkText ? _react.default.createElement(_Small.default, null, _react.default.createElement(_UILink.default, {
        onClick: onLinkClick
      }, _react.default.createElement(_FormattedMessage.default, {
        message: linkText
      }))) : null);
    }
  }]);
  return FormLabelWithHelpLink;
}(_react.Component);

exports.default = FormLabelWithHelpLink;
FormLabelWithHelpLink.propTypes = {
  primaryText: _propTypes.default.string.isRequired,
  linkText: _propTypes.default.string,
  onLinkClick: _propTypes.default.func,
  required: _propTypes.default.bool
};
FormLabelWithHelpLink.defaultProps = {
  onLinkClick: function onLinkClick() {}
};
module.exports = exports.default;